import { Hitbox } from './hitbox';

export class BattlefieldHitbox extends Hitbox {
    render({ view }) {
        view
            .setPointerBehavior('none')
    }
}